import React from 'react';
import { Helmet } from 'react-helmet';

var Schema = function Schema(_ref) {
  var schema = _ref.schema;
  return React.createElement(Helmet, {
    defer: false
  }, React.createElement("script", {
    type: "application/ld+json"
  }, "".concat(JSON.stringify(schema))));
};

export default Schema;